const getAdjustedQty = (item, recalculate) => {
  return !recalculate ? item?.AdjQty || 0 : item?.RecQty;
};

const getCost = (item) => {
  return item?.EachItemCost || 0;
};

// recalculate - while saving from settings recalculate AdjQty as RecQty, then calculate cost.
export const getItemCost = (item = {}, reset = false, recalculate = false) => {
  const itemAdjQty = getAdjustedQty(item, recalculate);
  const itemCost = getCost(item);

  if (reset) {
    return {
      ...item,
      AdjCost: 0,
      AdjQty: 0,
      ReleaseDate: null,
      ReleaseStatus: "",
      PONumber: "",
    };
  }

  if (itemAdjQty === 0 || itemCost === 0) {
    return {
      ...item,
      AdjCost: !item?.AdjCost || !itemAdjQty ? 0 : item?.AdjCost,
    };
  }

  return {
    ...item,
    AdjCost: itemAdjQty * itemCost,
    ...(recalculate && {
      AdjQty: item?.RecQty,
    }),
  };
};
